// @ts-strict-ignore
import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {
  ConversionWindowUnit,
  FunnelOrder,
  FUNNELS_MATH_TYPES,
  MetricType,
  TopLevelMetricType,
} from 'common/types/reports/bookmark';
import {RestrictEntitySaving} from 'common/report/constants';
import {getAllSavedBehaviors} from 'common/query-builder/query-entry-section/row-types/metric-entry/metrics/behavior-utils';
import {BehaviorsResource} from 'common/report/model-resources/behaviors';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';

export function hasSavedFunnelBehaviors({behaviors}: {behaviors: BehaviorsResource}): boolean {
  const savedBehaviors = getAllSavedBehaviors({behaviors, metricType: MetricType.Funnel});
  return savedBehaviors.length > 0;
}

export function canSaveForPlan(currentProject: CurrentProject): boolean {
  return Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.BehaviorMetrics));
}

export function getNewEntry({isExpanded}: {isExpanded: boolean}): MetricEntry {
  return {
    type: TopLevelMetricType.MetricEntry,
    behavior: {
      type: MetricType.Funnel,
      name: null,
      conversionWindowDuration: 7,
      conversionWindowUnit: ConversionWindowUnit.Day,
      funnelOrder: FunnelOrder.Loose,
      aggregateBy: [],
      behaviors: [
        {
          type: MetricType.Event,
          name: null,
          filters: [],
        },
        {
          type: MetricType.Event,
          name: null,
          filters: [],
        },
      ],
    },
    measurement: {
      aggregationOperator: FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE,
      stepIndex: null,
    },
    isExpanded,
  };
}
